import { gsap } from 'gsap';
import Flickity from 'flickity';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

import 'flickity-imagesloaded';
import 'flickity-bg-lazyload';
import 'flickity-fade';
import { bind, throttle } from 'lodash';
import Isotope from 'isotope-layout';
const MOS = {};
window.MOS = MOS;

(() => {
  const gMapScript = 'https://maps.googleapis.com/maps/api/js?key=';
  const SCREENMDMAX = 1199;
  const HEADER_HEIGHT = 100;
  let winSize = 0;
  const calcWinSize = () => {
    winSize = { width: window.innerWidth, height: window.innerHeight };
  };

  const scrollTo = (elt, duration, target, offsetY) => {
    console.log('scrollto', elt, duration, target);
    gsap.to(
      window,
      {
        duration: duration || 1,
        scrollTo: elt.getBoundingClientRect().top + window.scrollY - (offsetY || 0),
        onComplete: () => {
          if (target !== undefined) {
            // window.location.hash = target;
          }
        },
      },
    );
  };

  class AccordionMenuItem {
    constructor(elt, opts) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('.c-accordion-menu__btn');
      this.DOM.link = this.DOM.elt.querySelector('.c-accordion-menu__link');
      this.DOM.content = this.DOM.elt.querySelector('.c-accordion-menu__content');
      this.isOpen = this.DOM.elt.classList.contains('is-active')
      this.opts = opts;
    }
    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      const self = this;
      if (action === 'SHOW') {
        gsap.to(self.DOM.content, { duration: 0.6, height: 'auto' });
        if (self.DOM.btn && self.opts.scrollTo === true) {
          scrollTo(self.DOM.btn, 1, null, HEADER_HEIGHT);
        }
        self.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(self.DOM.content, { duration: 0.4, height: 0, onComplete: () => {
          self.DOM.elt.classList.remove('is-active');
        } });
      }
    }
  }
  class AccordionMenu {
    constructor(elt) {
      const self = this;
      self.DOM = { elt };
      self.settings = self.DOM.elt.hasAttribute('data-accordion') ? JSON.parse(self.DOM.elt.getAttribute('data-accordion')) : {};
      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.c-accordion-menu__item')).forEach(item => self.menuItems.push(new AccordionMenuItem(item, self.settings)));
      self.init();
      console.log('AccordioMenu::init', self.menuItems.length, self.settings);
    }

    init() {
      this.current = 0;
      this.initEvents();
      if (typeof this.settings !== 'undefined' && 'autoOpen' in this.settings) {
        this.showContent(this.settings.autoOpen);
      }
    }

    initEvents() {
      for (const [pos, item] of this.menuItems.entries()) {
        if (item.DOM.btn) {
          item.DOM.btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
        if (item.DOM.link) {
          item.DOM.link.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
      }
    }

    showContent(pos) {
      console.log('POS', pos);
      if (typeof this.settings !== 'undefined' && 'autoClose' in this.settings) {
        if (this.current !== pos && this.menuItems[this.current].isOpen) {
          this.menuItems[this.current].hide();
        }
      }
      this.menuItems[pos].toggleCurrent();
      this.current = pos;
    }
  }
  class Carousels {
    constructor(element) {
      if (element.querySelector('.js-carousel')) {
        console.log(
          'Carousels::init',
          element.querySelectorAll('.js-carousel').length,
        );
        const self = this;
        self.DOM = {
          elts: [],
          eltWrapper: element,
        };
        element.querySelectorAll('.js-carousel').forEach((elt) => {
          self.DOM.elts.push(elt);
        });
        self.flcks = [];
        self.init();
      }
    }
    init() {
      let idx = 0;
      const self = this;
      self.DOM.elts.forEach((instance) => {
        console.log('Carousels::init', idx);
        const flck = new Flickity(instance);
        if (
          self.DOM.eltWrapper.querySelector('.btn--next') &&
          self.DOM.eltWrapper.querySelector('.btn--prev')
        ) {
          self.DOM.eltWrapper
            .querySelector('.btn--next')
            .addEventListener('click', (e) => {
              e.preventDefault();
              flck.next(true, false);
            });
          self.DOM.eltWrapper
            .querySelector('.btn--prev')
            .addEventListener('click', (e) => {
              e.preventDefault();
              flck.previous(true, false);
            });
        }
        self.flcks.push(flck);
        Carousels.updateSlideAccessibility(flck);
        idx += 1;
      });
    }

    static updateSlideAccessibility(flck) {
      if (flck !== undefined) {
        console.log('Carousels::updateSlideAccessibility');
        flck.cells.forEach((cell) => {
          const isHidden = cell.element.getAttribute('aria-hidden') === 'true';
          const focusables = cell.element.querySelectorAll('a, button, input, [tabindex]');
          focusables.forEach((el) => {
            if (isHidden) {
              el.setAttribute('tabindex', '-1');
            } else {
              el.removeAttribute('tabindex');
            }
          });
        });
      }
    }
  }
  class DDMenuItem {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('button');
      this.DOM.content = this.DOM.elt.querySelector('.menu-item__level');
      this.isOpen = this.DOM.elt.classList.contains('is-active');
      this.init();
    }

    init() {
      const self = this;
      self.DOM.btn.addEventListener('click', self.toggleCurrent.bind(self));
    }

    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      if (action === 'SHOW') {
        gsap.to(this.DOM.content, { height: 'auto', duration: 0.3 });
        this.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(this.DOM.content, { height: 0, duration: 0.3 });
        this.DOM.elt.classList.remove('is-active');
      }
    }
  }
  class SideNav {
    constructor(elt, eltWrapper) {
      if (document.querySelector(elt) && document.querySelector(eltWrapper)) {
        const self = this;
        self.DOM = { elt: document.querySelector(elt) };
        self.DOM.eltWrapper = document.querySelector(eltWrapper);
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.DOM.openBtn = self.DOM.eltWrapper.querySelector('.btn-burger');
        self.isOpen = false;
        self.initEvents();
      }
    }
    initEvents() {
      console.log('SideNav::initEvents');
      const self = this;
      self.DOM.openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.isOpen) {
          this.toggle('close');
        } else {
          this.toggle('open');
        }
      });
      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.menu__item--ddm')).forEach(item => this.menuItems.push(new DDMenuItem(item)));
    }

    toggle(action, _self) {
      const self = _self || this;
      self.isOpen = action === 'open';

      if (self.isOpen) {
        self.DOM.elt.classList.add('is-open');
        self.DOM.openBtn.classList.add('is-active');
      } else {
        self.DOM.elt.classList.remove('is-open');
        self.DOM.openBtn.classList.remove('is-active');
      }
    }
  }

  class Search {
    constructor(elt) {
      const self = this; 
      self.DOM = { elt };
      self.DOM.closeBtn = self.DOM.elt.querySelector('.btn-close');
      self.DOM.openBtn = document.querySelectorAll('.btn-search');
      self.isOpen = self.DOM.elt.classList.contains('is-active');
      self.DOM.searchInput = this.DOM.elt.querySelector('.c-search__input');
      self.initEvents();
    }

    initEvents() {
      console.log('#Search::init');
      const self = this;
      if (self.DOM.closeBtn) {
        self.DOM.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          self.hide();
        });
      }

      if (self.DOM.openBtn) {
        self.DOM.openBtn.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            self.show();
          });
        });
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }

    toggle(action) {
      const self = this;
      if (action === 'SHOW') {
        gsap.to(self.DOM.elt, { duration: 0.3, alpha: 1, onComplete:() => {
          self.DOM.searchInput.focus();
        } });
        self.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(self.DOM.elt, {
          duration: 0.3, alpha: 0, onComplete: () => {
            self.DOM.searchInput.blur();
            self.DOM.searchInput.value = '';
            self.DOM.elt.classList.remove('is-active');
          }
        });
      }
    }
  }

  class MainNav {
    constructor(elt, eltWrapper) {
      const self = this;
      if (document.querySelector(elt) && document.querySelector(eltWrapper)) {
        self.DOM = { elt: document.querySelector(elt) };
        self.DOM.eltWrapper = document.querySelector(eltWrapper);
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.DOM.toggleBtn = document.querySelector('.btn-burger');
        self.DOM.closeBtn = self.DOM.eltWrapper.querySelector('.btn-close');
        self.isOpen = false;
        self.initEvents();
      }
    }

    initEvents() {
      console.log('MainNav::initEvents');
      const self = this;
      self.DOM.toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (self.isOpen) {
          self.toggle('close');
          document.querySelector('body').classList.remove('is-open');
        } else {
          self.toggle('open');
          document.querySelector('body').classList.add('is-open');
        }
      });

      if (self.DOM.closeBtn) {
        self.DOM.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle('close');
        });
      }

      if (MOS.Util.hasTouchScreen() || winSize.width < 1200) {
        self.menuItems = [];
        Array.from(self.DOM.elt.querySelectorAll('.menu__item--ddm')).forEach(item => this.menuItems.push(new DDMenuItem(item)));
      }

      if (self.settings.sticky !== undefined && self.settings.sticky && winSize.width > SCREENMDMAX) {
        window.addEventListener('scroll', throttle(self.onScroll.bind(self), 500, { leading: true, trailing: true }));
      }
    }

    open() {
      this.DOM.elt.classList.add('is-open');
      this.DOM.toggleBtn.classList.add('is-active');
      this.isOpen = true;
    }

    close() {
      this.DOM.elt.classList.remove('is-open');
      this.DOM.toggleBtn.classList.remove('is-active');
      this.isOpen = false;
    }

    toggle(action, _self) {
      const self = _self || this;
      self.isOpen = action === 'open';

      if (self.isOpen) {
        self.open();
      } else {
        self.close()
      }
    }

    onScroll() {
      const windowScrollY = window.scrollY;
      if (windowScrollY > 50) {
        this.DOM.elt.classList.add('is-sticky');
        this.DOM.isSticky = true;
      } else {
        this.DOM.elt.classList.remove('is-sticky');
        this.DOM.isSticky = false;
      }
      // console.log('StickyNav::scrolling', windowScrollY);
    }
  }

  class Header {
    constructor(elt) {
      const self = this;
      if (document.querySelector(elt)) {
        self.DOM = { elt: document.querySelector(elt) };
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.initEvents();
      }
    }

    initEvents() {
      console.log('Header::initEvents');
      const self = this;
      window.addEventListener('scroll', throttle(self.onScroll.bind(self), 500, { leading: true, trailing: true }));

      // if (self.settings.sticky !== undefined && self.settings.sticky && winSize.width > SCREENMDMAX) {
      // }
    }

    onScroll() {
      const windowScrollY = window.scrollY;
      if (windowScrollY > 50) {
        this.DOM.elt.classList.add('is-sticky');
        this.DOM.isSticky = true;
      } else {
        this.DOM.elt.classList.remove('is-sticky');
        this.DOM.isSticky = false;
      }
      // console.log('StickyNav::scrolling', windowScrollY);
    }
  }

  class IsotopeGrid {
    constructor(eltWrapper) {
      this.DOM = { eltWrapper };
      this.DOM.elt = this.DOM.eltWrapper.querySelector('.js-isotope');
      this.settings = this.DOM.elt && this.DOM.elt.hasAttribute('data-settings') ? JSON.parse(this.DOM.elt.getAttribute('data-settings')) : {};
      this.init();
    }

    init() {
      const self = this;
      const opt = {};
      const iso = new Isotope(this.DOM.elt, {
        itemSelector: '.js-isotope-item',
        percentPosition: true,
        layoutMode: self.settings.layoutMode !== 'undefined' ? self.settings.layoutMode : 'masonry',
        gutter: 20,
        hiddenStyle: {
          opacity: 0,
        },
        visibleStyle: {
          opacity: 1,
        },
        fitRows: {
          equalheight: true,
        },
      });

      const concatValues = (filters) => {
        let value = '';
        Object.keys(filters).forEach((prop) => {
          value += filters[prop].join('');
        });
        return value;
      };
      self.DOM.elt.addEventListener('load', () => {
        iso.layout();
      }, true);
      self.filters = {};
      // filter by querystring
      if ('URLSearchParams' in window && self.settings.filterByQueryString !== 'undefined' && self.settings.filterByQueryString === true) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        let filterby = '';
        if (urlSearchParams.size > 0 && params.hasOwnProperty('filterby')) {
          filterby = `.${params.filterby}`;

          if (self.DOM.eltWrapper.querySelector('.js-filter-by-button-group')) {
            document.querySelector(`[data-filter-value='${filterby}']`).classList.add('is-selected');
            // buttonGroups[0].querySelector('.is-selected').classList.remove('is-selected');
          }
        } else {
          const segments = window.location.pathname.split('/');
          segments.pop();
          filterby = `.${segments[segments.length - 1]}`;
        }
        iso.arrange({ filter: filterby });
      }

      // filter by dropdown
      if (self.DOM.eltWrapper.querySelector('select')) {
        // Helper function to concatenate filter values

        self.DOM.eltWrapper.querySelectorAll('select').forEach((ddm) => {
          ddm.addEventListener('change', (e) => {
            const select = e.target;
            const filterGroup = select.getAttribute('data-filter-group');
            self.filters[filterGroup] = [e.target.value];
            const filterValue = concatValues(self.filters);
            iso.arrange({ filter: filterValue });
            console.log('#IsotopeGrid::Dropdown FilterBy:', self.filters);
          });
        });
      }

      // filter by button group
      if (self.DOM.eltWrapper.querySelector('.js-filter-by-button-group')) {
        const filterByBtnGroup = self.DOM.eltWrapper.querySelector('.js-filter-by-button-group');
        filterByBtnGroup.addEventListener('click', function (e) {
          // only button clicks
          if (!e.target.matches('button')) {
            return;
          }
          const filterValue = e.target.getAttribute('data-filter-value');
          iso.arrange({ filter: filterValue });
          if (self.settings.filterByQueryString !== 'undefined' && self.settings.filterByQueryString == true) {
            if ('URLSearchParams' in window) {
                const searchParams = new URLSearchParams(window.location.search)
                searchParams.set('filterby', filterValue.replace('.', ''));
                var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
                history.pushState(null, '', newRelativePathQuery);
            }
          }
          console.log('#IsotopeGrid::ButtonGroup FilterBy:', filterValue, newRelativePathQuery);
        });

        // change is-selected class on buttons
        const buttonGroups = self.DOM.eltWrapper.querySelectorAll('.js-filter-by-button-group');
        for ( var i = 0, len = buttonGroups.length; i < len; i++ ) {
          buttonGroups[i].addEventListener('click', onButtonGroupClick);
        }

        function onButtonGroupClick(e) {
          // only button clicks
          if (!e.target.matches('button')) {
            return;
          }
          const button = e.target;
          if (button !== null) {
            buttonGroups[0].querySelector('.is-selected').classList.remove('is-selected');
            button.classList.add('is-selected');
          }
        }
      }

      // filter by checkboxes
      if (self.DOM.eltWrapper.querySelector('.js-filter-by-checkboxes')) {
        const checkboxes = self.DOM.eltWrapper.querySelectorAll('.js-filter-by-checkboxes input');
        console.log(checkboxes);
        checkboxes.forEach((cbx) => {
          IsotopeGrid.updateFilter(iso, cbx, self.filters, { fromQueryString: true });
          cbx.addEventListener('change', (e) => {
            IsotopeGrid.updateFilter(iso, e.currentTarget, self.filters, { fromQueryString: false });
            IsotopeGrid.updateCheckboxQueryStringParams(self.DOM.eltWrapper);
          });
        });
      }

      // equal height
      if (self.settings.layoutMode !== 'undefined' && self.settings.layoutMode === 'fitRows') {
        iso.on('arrangeComplete', () => {
          IsotopeGrid.setEqualHeights(self.DOM.elt);
        });
        window.addEventListener('resize', throttle(self.onResize.bind(self, iso), 500, { leading: true, trailing: true }));
      }
      console.log('#IsotopeGrid::init');
    }
    static updateQueryStringParam(group, value) {
      const url = new URL(window.location.href);
      if (value && value !== '') {
        url.searchParams.set(group, value);
      } else {
        url.searchParams.delete(group);
      }
      window.history.replaceState({}, '', url);
      console.log('#IsotopeGrid::updateQueryStringParam', group, value, url.toString());
    }
    // Helper function to update URL query string for all checkbox filter groups
    static updateCheckboxQueryStringParams(wrapper) {
      const url = new URL(window.location.href);
      // For each filter group
      wrapper.querySelectorAll('.c-accordion-menu__content[data-filter-group]').forEach((groupEl) => {
        const group = groupEl.getAttribute('data-filter-group');
        const checked = Array.from(groupEl.querySelectorAll('input[type=checkbox]:checked:not(.all)'))
          .map(cb => cb.value.replace(/^\./, '')) // Remove leading dot
          .filter(val => val && val !== '');
        if (checked.length > 0) {
          url.searchParams.set(group, checked.join(','));
        } else {
          url.searchParams.delete(group);
        }
      });
      window.history.replaceState({}, '', url);
    }
    static updateFilter(iso, cbx, filters, opts) {
      IsotopeGrid.manageSelection(cbx, filters, opts);
      const comboFilter = IsotopeGrid.getComboFilter(filters);
      iso.arrange({ filter: comboFilter });
      console.log('#IsotopeGrid::Checkboxes FilterBy:', filters, 'ComboFilters:', comboFilter);
    }

    static getComboFilter(filters) {
      let i = 0;
      let comboFilters = [];
      const message = [];
      const keys = Object.keys(filters);
      const values = Object.values(filters);
      for (let f = 0; f < keys.length; f += 1) {
        if (Object.prototype.hasOwnProperty.call(values, f)) {
          message.push(values[f].join(' '));
          const filterGroup = values[f];
          if (!filterGroup.length) {
            continue;
          }
          if (i === 0) {
            // copy to new array
            comboFilters = filterGroup.slice(0);
          } else {
            const filterSelectors = [];
            // copy to fresh array
            const groupCombo = comboFilters.slice(0);
            // merge filter Groups
            for (let k = 0, len3 = filterGroup.length; k < len3; k += 1) {
              for (let j = 0, len2 = groupCombo.length; j < len2; j += 1) {
                filterSelectors.push(groupCombo[j] + filterGroup[k]); // [ 1, 2 ]
              }
            }
            // apply filter selectors to combo filters for next group
            comboFilters = filterSelectors;
          }
          i += 1;
        }
      }
      const comboFilter = comboFilters.join(', ');
      return comboFilter;
    }

    static manageSelection(checkbox, filters, opts = {}) {
      const cbx = checkbox;
      const groupElt = cbx.parentElement.parentElement;
      const group = groupElt.getAttribute('data-filter-group');
      if (typeof group !== 'undefined') {
        let filterGroup = filters[group];
        const checkedTotal = groupElt.querySelectorAll('input[type=checkbox]:checked').length;
        if (!filterGroup) {
          filterGroup = [];
          filters[group] = [];
        }
        const isAll = checkbox.classList.contains('all');

        // Handle query string initialization
        if (opts.fromQueryString) {
          const urlSearchParams = new URLSearchParams(window.location.search);
          const params = Object.fromEntries(urlSearchParams.entries());
          if (Object.hasOwn(params, group)) {
            // Uncheck all first
            groupElt.querySelectorAll('input[type=checkbox]').forEach((elt) => {
              elt.checked = false;
            });
            // Check those from query string
            const values = params[group].split(',');
            values.forEach((val) => {
              const filterVal = val.startsWith('.') ? val.toLowerCase() : `.${val.toLowerCase()}`;
              const input = groupElt.querySelector(`input[value="${filterVal}"]`);
              if (input) {
                input.checked = true;
                if (!filters[group].includes(filterVal)) {
                  filters[group].push(filterVal);
                }
              }
            });
            // If nothing checked, check 'all'
            if (filters[group].length === 0) {
              const allInput = groupElt.querySelector('input.all');
              if (allInput) allInput.checked = true;
            }
            return;
          }
        }

        if (isAll) {
          delete filters[group];
          if (!cbx.checked) {
            cbx.checked = true;
          }
        }
        const idx = filterGroup.indexOf(cbx.value);
        if (cbx.checked) {
          const selector = isAll ? 'input' : 'input.all';
          groupElt.querySelectorAll(selector).forEach((elt) => {
            if (elt !== cbx) {
              elt.checked = false;
            }
          });
          if (!isAll && idx === -1) {
            filters[group].push(cbx.value);
          }
        } else if (!isAll) {
          filters[group].splice(idx, 1);
          if (checkedTotal === 0) {
            groupElt.querySelector('input.all').checked = true;
          }
        }
      }
    }

    static setEqualHeights(elt) {
      const items = elt.querySelectorAll('.js-isotope-item');
      let maxHeight = 0;

      items.forEach((el) => {
        el.style.height = 'auto'; // reset
        if (el.offsetHeight > maxHeight) maxHeight = el.offsetHeight;
      });

      items.forEach((el) => {
        el.style.height = `${maxHeight}px`;
      });
      console.log('#IsotopeGrid::setEqualHeights');
    }

    onResize(iso) {
      console.log('#IsotopeGrid::onResize');
      this.setEqualHeights(this.DOM.elt);
      iso.layout();
    }
  }

  function init() {
    let idx = 0;
    MOS.sideNav = new SideNav('.c-main-nav[data-menu-style="sidenav"]', '.c-main-nav__wrapper');
    MOS.mainNav = new MainNav('.c-main-nav', '.c-main-nav__wrapper');
    MOS.header = new Header('.main-header[data-menu-type="sticky"]');

    if (document.querySelectorAll('.c-accordion-menu')) {
      MOS.accordionMenu = [];
      document.querySelectorAll('.c-accordion-menu').forEach((element) => {
        MOS.accordionMenu.push(new AccordionMenu(element));
      });
    }

    if (document.querySelector('.js-carousel-wrapper')) {
      MOS.carousels = [];
      document.querySelectorAll('.js-carousel-wrapper').forEach((element) => {
        MOS.carousels.push(new Carousels(element));
      });
    }

    if (document.getElementById('gmap')) {
      MOS.GMap.load();
    }

    if (document.querySelector('.js-isotope')) {
      MOS.isotopes = [];
      idx = 0;
      document.querySelectorAll('.js-isotope-wrapper').forEach((eltWrapper) => {
        const isotope = new IsotopeGrid(eltWrapper);
        MOS.isotopes.push({ id: `isotope${idx}`, isotope });
        idx += 1;
      });
    }
    if (document.querySelector('.c-search')) {
      const search = new Search(document.querySelector('.c-search'));
    }
  }
  MOS.GMap = {
    load: () => {
      if (typeof MOS.GMap.isLoaded === 'undefined') {
        const self = MOS.GMap;
        MOS.GMap.isLoaded = false;
        self.isLoaded = false;
        self.DOM = {
          elt: document.getElementById('gmap'),
          zoomInBtn: document.getElementById('gmap-zoom-in'),
          zoomOutBtn: document.getElementById('gmap-zoom-out'),
        };
        self.settings = JSON.parse(self.DOM.elt.getAttribute('data-settings'));
        self.marker = self.settings.marker;
        self.locations = self.settings.locations;
        self.zoom = parseInt(self.settings.zoom, 0) || 14;
        self.apiKey = self.DOM.elt.getAttribute('data-gmapkey');
        self.markers = [];
        const script = document.createElement('script');
        script.addEventListener('load', MOS.GMap.loaded);
        script.src = `${gMapScript + self.apiKey}&callback=window.MOS.GMap.init&libraries=marker&loading=async`;
        document.body.appendChild(script);
      } else {
        MOS.GMap.loaded();
        MOS.GMap.init();
      }
    },
    loaded: () => {
      MOS.GMap.isLoaded = true;
    },
    init: () => {
      if (google.maps) {
        console.log('MOS.GMap::init');
        const self = MOS.GMap;
        let marker;
        const center = {
          lng: parseFloat(self.locations[0].lng),
          lat: parseFloat(self.locations[0].lat),
        };

        self.styles = {
          light: [
            {
              elementType: 'geometry',
              stylers: [
                {
                  color: '#f5f5f5',
                },
              ],
            },
            {
              elementType: 'labels.icon',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#616161',
                },
                {
                  visibility: 'off',
                },
              ],
            },
            {
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  color: '#f5f5f5',
                },
              ],
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#bdbdbd',
                },
              ],
            },
            {
              featureType: 'poi',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#eeeeee',
                },
              ],
            },
            {
              featureType: 'poi',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#757575',
                },
              ],
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#e5e5e5',
                },
              ],
            },
            {
              featureType: 'poi.park',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#9e9e9e',
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#ffffff',
                },
              ],
            },
            {
              featureType: 'road.arterial',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#757575',
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#dadada',
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#616161',
                },
              ],
            },
            {
              featureType: 'road.local',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#9e9e9e',
                },
              ],
            },
            {
              featureType: 'transit.line',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#e5e5e5',
                },
              ],
            },
            {
              featureType: 'transit.station',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#eeeeee',
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#c9c9c9',
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#9e9e9e',
                },
              ],
            },
          ],
          dark: [{
            "version": "1",
            "settings": {
              "landscape": {
                "fill": {
                  "color": "#00508f"
                }
              },
              "administrative": {
                "text": {
                  "fill": {
                    "color": "#0069ab"
                  },
                  "stroke": {
                    "color": "transparent"
                  }
                }
              },
              "poi": {
                "text": {
                  "fill": {
                    "color": "#0069ab"
                  },
                  "stroke": {
                    "color": "transparent"
                  },
                  "visibility": "off"
                }
              },
              "road": {
                "fill": {
                  "color": "#0069ab"
                }
              },
              "transit": {
                "fill": {
                  "color": "#0069ab"
                }
              },
              "water": {
                "fill": {
                  "color": "#003b68"
                },
                "text": {
                  "fill": {
                    "color": "#0069ab"
                  }
                }
              },
              "all": {
                "text": {
                  "fill": {
                    "color": "#f2f2f2"
                  },
                  "stroke": {
                    "color": "#000000",
                    "weight": 0.96,
                    "saturation": 9
                  }
                }
              },
              "administrative.country": {
                "text": {
                  "fill": {
                    "color": "#0069ab"
                  }
                }
              },
              "administrative.province": {
                "visibility": "off"
              }
            }
          },          
          ],
        };

        const theme = (self.settings.theme !== 'undefined' && self.settings.theme === 'dark') ? self.styles.dark : self.styles.light;
        self.map = self.createMap(self.settings.id, self.DOM.elt, center, self.zoom, theme);
        self.locations.forEach((location, index) => {
          const id = index;
          const markerImg = document.createElement('img');
          markerImg.src = location.marker;
          marker = MOS.GMap.createMarker(self,
            self.map,
            location.id,
            location.title,
            location.description,
            location.url,
            location.lng,
            location.lat,
            location.marker,
          );
          // google.maps.event.addListener(marker, 'click', () => {
          //   self.onMarkerClicked(self.map, self.markers[id].marker);
          //   self.map.setZoom(self.zoom);
          // });
          self.markers.push({ id: location.id, marker });
          console.log( 'id', location.id);
        });
        self.initEvents();

        if (self.locations.length == 1) {
          self.map.setZoom(self.zoom);
        } else if (MOS.Util.hasTouchScreen() && winSize.width > SCREEN_SM_MAX) {
          console.log('GMAP::autocenter...');
          self.autoCenter(self.map);
        }
      }
    },
    initEvents: () => {
      const self = MOS.GMap;
      if (self.DOM.zoomInBtn) {
        google.maps.event.addDomListener(self.DOM.zoomInBtn, 'click', () => {
          const currentZoomLevel = self.map.getZoom();
          if (currentZoomLevel !== 21) {
            self.map.setZoom(currentZoomLevel + 1);
          }
        });
      }

      if (self.DOM.zoomInBtn) {
        google.maps.event.addDomListener(self.DOM.zoomOutBtn, 'click', () => {
          const currentZoomLevel = self.map.getZoom();
          if (currentZoomLevel !== 0) {
            self.map.setZoom(currentZoomLevel - 1);
          }
        });
      }
    },
    createMarker: (self, map, id, title, body, url, lng, lat, markerIco) => {
      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: { lat: parseFloat(lat), lng: parseFloat(lng) },
        id: id || parseInt(Math.random() * 10000, 0),
        map,
        content: self.buildContent(title, body, markerIco),
        // icon: markerIco || 'img/map-marker.png',
        // animation: google.maps.Animation.DROP,
      });
      marker.addListener("click", () => {
        self.toggleMarker(marker, id);
      });
      return marker;
    },
    createMap: (id, elt, coordinates, zoom, style) => {
      return new google.maps.Map(document.getElementById('gmap'), {
        zoom: zoom || 4,
        center: coordinates,
        disableDefaultUI: true,
        // styles: style,
        mapId: id
      });
    },
    onMarkerClicked: (map, marker) => {
      const infoWindow = new google.maps.InfoWindow({
        content: `<div class="map__info-panel"><h3 class="normal">${marker.title}</h3><p class="small">${marker.body}</p></div>`,
        maxWidth: 300,
      });
      infoWindow.open(map, marker);
    },
    autoCenter(map) {
      console.info('GMAP::autocenter');
      const bounds = new google.maps.LatLngBounds();
      MOS.GMap.markers.forEach((m) => {
        bounds.extend(m.marker.position);
      });
      map.fitBounds(bounds);
      map.panToBounds(bounds);
    },
    buildContent: (title, html, markerIco) => {
      const content = document.createElement('div');
      content.classList.add('c-gmap-card');
      content.innerHTML = `<div>
        <div class="icon">
          <img src="${markerIco}" alt="">
        </div>
        <div class="c-gmap-card__detail bg-grey">
          <div class="medium primary-font light margin--b-10">${title}</div>
          ${html}
        </div>
      </div>`;
      return content;
    },

    toggleMarker: (markerView, id) => {
      console.log('id', id)
      if (markerView.content.classList.contains('is-selected')) {
        markerView.content.classList.remove('is-selected');
        markerView.zIndex = null;
      } else {
        markerView.content.classList.add('is-selected');
        markerView.zIndex = 1;
      }
    },
  };
  MOS.Util = {
    hasTouchScreen: () => {
      let hasTouch = false;
      if ('ontouchstart' in window) {
        hasTouch = true;
      } else if ('maxTouchPoints' in navigator) {
        hasTouch = navigator.maxTouchPoints >= 1 && navigator.maxTouchPoints <= 10;
      } else if ('msMaxTouchPoints' in navigator) {
        hasTouch = navigator.msMaxTouchPoints > 0;
      } else {
        const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
        if (mQ && mQ.media === '(pointer:coarse)') {
          hasTouch = !!mQ.matches;
        } else if ('orientation' in window) {
          hasTouch = true; // deprecated, but good fallback
        } else {
          // Only as a last resort, fall back to user agent sniffing
          const UA = navigator.userAgent;
          hasTouch = (
            /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
            /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
          );
        }
      }
      return hasTouch;
    },
  };
  document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollToPlugin);
    calcWinSize();
    init();
  });
})();
